import { useNavigate } from 'react-router-dom'
import AppIcon from '../../app-icon.svg'
import HamburgerMenu from '../../scoring/components/HamburgerMenu'
import { useGolferStore } from '../../scoring/store/GolferStore'
import { useMetaStore } from '../../scoring/store/MetaStore'
import './NavHeader.css'

const NavHeader = () => {
  const group = useGolferStore((state) => state.group)
  const navigate = useNavigate()
  const logout = useMetaStore((state) => state.logout)
  const eventId = useMetaStore((state) => state.eventId)
  const pageTitle = useMetaStore((state) => state.pageTitle)
  const isAdmin = useMetaStore((state) => state.isAdmin)
  const finalized = useMetaStore((state) => state.finalized)
  const apiKey = useMetaStore((state) => state.apiKey)

  const menuItems = []

  menuItems.push({
    text: 'League Info',
    onClick: () => {
      navigate('/league/menu')
    },
  })

  menuItems.push({
    text: 'Enter Code',
    onClick: () => {
      navigate('/event/signin')
    },
  })

  if (eventId && apiKey) {
    menuItems.push({
      text: 'Leaderboard',
      onClick: () => {
        navigate('/leaderboard')
      },
    })
  }

  if (!finalized && group?.length > 0 && apiKey) {
    menuItems.push({
      text: 'Keep Score',
      onClick: () => {
        navigate('/scoreentry')
      },
    })
  }

  if (eventId && apiKey && !finalized) {
    menuItems.push({
      text: 'Group Setup',
      onClick: () => {
        navigate('/groupentry')
      },
    })
  }

  menuItems.push({
    text: 'Share Link',
    onClick: () => {
      navigate('/share')
    },
  })

  menuItems.push({
    text: 'Logout',
    onClick: () => {
      logout()
      navigate(isAdmin ? '/' : '/player-login')
    },
  })

  if (isAdmin) {
    menuItems.push({
      text: 'Admin',
      onClick: () => {
        navigate('/admin')
      },
    })
  }

  const titleStyle = {
    width: '100%',
    color: '#FFF',
    height: '60px',
    lineHeight: '60px',
    fontSize: '2em',
    fontWeight: 'bold',
    paddingLeft: '10px',
  }

  return (
    <div className="nav-header">
      <img src={AppIcon} width={'30px'} height={'60px'} alt="app icon" />
      <div style={titleStyle}>{pageTitle}</div>
      <div>
        <HamburgerMenu menuItems={menuItems} />
      </div>
    </div>
  )
}

export default NavHeader
